<template>
  <div class="owal-events-filter-panel__vertical-container">
    <div class="owal-events-filter-panel__vertical-container">
      <div class="owal-events-filter-panel__horizontal-container">
        <div class="owal-events-filter-panel__vertical-container">
          From:
          <owal-date-time-input
            :changeFunction="computeNewDatetime"
            :value="startDate"
            type="date"
            id="start-date"
            />
          <owal-date-time-input
            :changeFunction="computeNewDatetime"
            :value="startTime"
            type="time"
            id="start-time"
            />
        </div>
        <div class="owal-events-filter-panel__vertical-container">
          To:
          <owal-date-time-input
            :changeFunction="computeNewDatetime"
            :value="endDate"
            type="date"
            id="end-date"
            />
          <owal-date-time-input
            :changeFunction="computeNewDatetime"
            :value="endTime"
            type="time"
            id="end-time"
            />
        </div>
      </div>
      <div class="owal-events-filter-panel__horizontal-container">
        <owal-banner-button
          title="Search"
          accessory-type="none"
          class="owal-events-filter-panel__filter-panel-button"
          identifier="search-button"
          @click="searchEvents"
        />
      </div>
    </div>
    <div class="owal-events-filter-panel__vertical-container">
      <div class="checkbox-wrapper" v-if="checkboxItems.length > 1">
        Detectables:
        <owal-checkbox-panel
          :checkbox-items="checkboxItems"
          :change-function="checkboxFunction"
        />
      </div>
      <div class="checkbox-wrapper" v-if="cameraTagsOptions.length > 1">
        Camera Groups:
        <owal-checkbox-panel
          :checkbox-items="cameraTagsOptions"
          :change-function="checkboxFunctionNumber2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import OwalDateTimeInput from '@/libraries/owal-ui/inputs/OwalDateTimeInput.vue'
import { OwalBannerButton } from '@/libraries/owal-ui/'
import OwalCheckboxPanel from '@/libraries/owal-ui/inputs/OwalCheckboxPanel.vue'

export default {
  name: 'EventsBannerSlot',
  components: { OwalDateTimeInput, OwalBannerButton, OwalCheckboxPanel },
  props: ['text', 'cameraId', 'timestamp'],
  data: function () {
    return {
      datetimeFormat: {
        time: 'HH:mm:ss',
        date: 'YYYY-MM-DD',
      },
    }
  },
  computed: {
    ...mapGetters({
      filters: 'events/filters',
      queryParameters: 'events/queryParameters',
      detectablesByType: 'events/detectablesByType',
      cameraTags: 'events/cameraTags',
    }),
    endDate () {
      const timestamp = this.queryParameters.end ? moment.utc(this.queryParameters.end) : moment.utc()
      const dateString = timestamp.local().format(this.datetimeFormat.date)

      return dateString
    },
    endTime () {
      const timestamp = this.queryParameters.end ? moment.utc(this.queryParameters.end) : moment.utc()
      const dateString = timestamp.local().format(this.datetimeFormat.time)
      return dateString
    },
    startDate () {
      if (!this.queryParameters.start) {
        return undefined
      }
      const timestamp = this.queryParameters.start ? moment.utc(this.queryParameters.start) : undefined
      const dateString = timestamp.local().format(this.datetimeFormat.date)

      return dateString
    },
    startTime () {
      if (!this.queryParameters.start) {
        return undefined
      } else {
        const timestamp = this.queryParameters.start ? moment.utc(this.queryParameters.start) : undefined
        const dateString = timestamp.local().format(this.datetimeFormat.time)
        return dateString
      }
    },
    cameraTagSet() {
      return Array.from(new Set(this.cameraTags.map(camera => camera.cameraTags).flat()))
    },
    camerasByTag() {
      return this.cameraTags.reduce((prev, curr) => {
        for (let tag of curr.cameraTags) {
          if (tag in prev) {
            prev[tag].push(curr.cameraId)
          } else {
            prev[tag] = [curr.cameraId]
          }
        }
        return prev
      }, {})
    },
    cameraTagsOptions () {
      const items = this.cameraTagSet

      const tagsAndCameras = items.map(tag => {
        return {
          description: tag,
          checkboxValue: this.filters.cameraTags.includes(tag),
        }
      })
      return tagsAndCameras
    },
    checkboxItems () {
      const items = this.detectablesByType.map(detectable => {
        const item = { ...detectable, checkboxValue: this.filters.detectables.includes(detectable.description) }
        return item
      })
      return items
    },
  },
  methods: {
    ...mapMutations({
      setQueryStartDate: 'events/setQueryStartDate',
      setQueryEndDate: 'events/setQueryEndDate',
    }),
    updateAreaFilters(event) {
    },
    computeNewDatetime: function (target) {
      /** From the target object we have:
       * target.value: the value selected by the user
       * target.type: the type of input (i.e. date, time)
       * target.id: the string identifier, with the format {end/start}-{date/time}
       */
      let timestamp
      const mutations = {
        start: this.setQueryStartDate,
        end: this.setQueryEndDate,
      }
      const id = target.id.replace(/-\w*/, '')
      /**
       * incoming value is local time (i.e. moment() interprets as local, moment.utc() interprets as utc)
       * https://stackoverflow.com/questions/50608132/difference-between-moment-utcdate-and-momentdate-utc
       */
      const incoming = moment(target.value, this.datetimeFormat[target.type])
      const localcurrentDatetime = this.queryParameters[id] ? moment.utc(this.queryParameters[id]).local() : moment()

      // convert incoming date to utc and use string template to update store
      if (target.type === 'date' && incoming.isValid()) {
        timestamp = moment(`${incoming.format(this.datetimeFormat.date)} ${localcurrentDatetime.format(this.datetimeFormat.time)}`, `${this.datetimeFormat.date} ${this.datetimeFormat.time}`)
      } else if (target.type === 'time' && incoming.isValid()) {
        timestamp = moment(`${localcurrentDatetime.format(this.datetimeFormat.date)} ${incoming.format(this.datetimeFormat.time)}`, `${this.datetimeFormat.date} ${this.datetimeFormat.time}`)
      } else {
        console.debug('Unknown date or time input')
      }
      mutations[id](timestamp.utc().format())
    },
    searchEvents: function () {
      const params = {
        limit: 500,
      }

      const endTime = moment.utc(this.queryParameters.end)
      const startTime = moment.utc(this.queryParameters.start)
      if (startTime && (startTime.valueOf() > endTime.valueOf())) {
        alert('Error: start time cannot be later than end time.')
        return
      }

      if (endTime.isValid()) {
        params.since = startTime.format()
      }

      if (startTime.isValid()) {
        params.until = endTime.format()
      }

      this.$store.dispatch('events/clearEventsData')
      console.log('LoadEventsForDomain called from owalfilterpanel.vue searchEvents with params', params)
      this.$store.dispatch('events/loadEventsForDomain', params)
    },
    checkboxFunction: function (event) {
      this.$store.commit('events/updateFilters', { filter: event.target.id, add: event.target.checked, category: 'detectables' })
    },
    checkboxFunctionNumber2: function (event) {
      this.$store.commit('events/updateFilters', { filter: event.target.id, add: event.target.checked, category: 'cameraTags' })
    },
    updateCameraFilters: function (event) {
      this.$store.commit('events/updateFilters', { filter: event.target.id, add: event.target.checked, category: 'cameras' })
    },
  },
}
</script>

<style scoped>
  .owal-events-filter-panel__horizontal-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: .5rem .5rem .5rem 1rem;
    background-color: #ffffff;
    font-family: 'Lato-Italic', sans-serif;
  }

  .owal-events-filter-panel__vertical-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #ffffff;
     padding: .5rem .5rem .5rem 1rem;
    font-family: 'Lato-Italic', sans-serif;
  ;
  }

  .owal-events-filter-panel__vertical-container-right-panel input {
    height: 74px;
  }
  .checkbox-wrapper {
    width: 100%;
  }

</style>
